<template>
  <!-- 客服跟踪列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="btnList1 wtl_btnList" ref="btnList">
      <div class="btnList1 wtl_btnList1">
        <el-button class="itemBtn btnColor" @click="financeExamineBtn(1)"
          >添加</el-button
        >
        <el-button class="itemBtn btnColor" @click="financeExamineBtn(2)"
          >修改</el-button
        >
        <el-button class="itemBtn btnColor" @click="delBtns">删除</el-button>
        <el-button class="itemBtn btnColor" @click="myModel"
          >列表设置</el-button
        >
        <el-dropdown @command="handleCommand_dc">
          <el-button class="dropdownBtn">
            导出
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="dcmb">下载导出模板</el-dropdown-item>
            <el-dropdown-item command="scmb">保存(上传)模板</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="singleinpbtn wtl_queryBoxNew">
        <el-button class="seniorbut" @click="queryBtn_ok" icon="el-icon-search"
          >查询</el-button
        >
        <el-tooltip content="查询项恢复初始状态" placement="top">
          <div class="condition" @click="queryBtn_cz">清除</div>
        </el-tooltip>
        <!-- <el-tooltip content="查询更多条件" placement="top">
          <div class="condition" @click="more">{{ MoreConditions }}</div>
        </el-tooltip> -->
      </div>
    </div>
    <!-- 查询条件框 -->
    <el-form :model="queryData">
      <div
        ref="queryCriteria"
        class="HeadInputbox"
        :class="{ HeadInputbox1: judge, active: isActive }"
      >
        <div class="item_right">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          >
          </multitime>
          <div class="singleinp">
            <div class="singleinpleft">运单跟踪单号:</div>
            <div class="singleinpright">
              <el-input
                class="input"
                v-model.trim="queryData.documentNumber"
                placeholder="请输入"
                clearable
                @keyup.enter.native="queryBtn_ok"
              ></el-input>
            </div>
          </div>
          <div class="singleinp">
            <div class="singleinpleft">内容:</div>
            <div class="singleinpright">
              <el-input
                class="input"
                v-model="queryData.content"
                placeholder="请输入"
                clearable
                @keyup.enter.native="queryBtn_ok"
              ></el-input>
            </div>
          </div>
          <div class="singleinp">
            <div class="singleinpleft">类型:</div>
            <div class="singleinpright">
              <el-select
                class="queryInput"
                v-model="queryData.documentStatus"
                filterable
                placeholder="请选择"
                clearable
                @change="queryBtn_ok"
              >
                <el-option
                  v-for="item in documentStatusList"
                  :key="item.statusVal"
                  :label="item.showName"
                  :value="item.statusVal"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="singleinp" style="flex: 1; max-width: 18%">
            <div class="singleinpleft">运单轨迹显示:</div>
            <div class="singleinpright">
              <el-select
                class="queryInput"
                v-model="queryData.isShow"
                filterable
                placeholder="请选择"
                clearable
                @change="queryBtn_ok"
              >
                <el-option
                  v-for="(item, index) in approveStatusList"
                  :key="index"
                  :label="item.showName"
                  :value="item.statusVal"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 表格 -->
    <div class="tableBox" ref="tableWrapper">
      <el-table
        :height="tableHeigth"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        :row-class-name="tableRowClassName"
        highlight-current-row
        border
        :header-cell-style="{ background: '#f0f0f0' }"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            show-overflow-tooltip
            :key="index"
            :label="item.name"
            :prop="item.field"
            :min-width="item.width"
            sortable
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column label="查看附件" width="80">
          <template slot-scope="scope">
            <el-button
              @click="lookFile(scope.row.recordId)"
              type="text"
              size="mini"
              >查看附件</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- //排序 -->
    <div>
      <!-- 自定义表头排序 -->
      <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable>
    </div>
    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageNum"
      :total="total"
      :sizeList="sizeList"
      :size="size"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <div>
      <!-- 上传模板弹窗 -->
      <el-dialog
        title="上传编辑好的导出模板"
        :visible.sync="show_upload"
        append-to-body
        width="40%"
        center
      >
        <div>
          <el-upload
            :action="uploadUrl"
            :show-file-list="true"
            :file-list="fileList"
            :limit="1"
            :http-request="uploadSectionFile"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">上传模板</div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="show_upload = false">关 闭</el-button>
        </div>
      </el-dialog>
      <!-- 新建 -->
      <addCustomerTarck
        :showDia1="showDia1"
        :documentNumbers="documentNumbers"
        @confirmAdd="confirmAdd"
        @closeDia1="closeDia1"
      ></addCustomerTarck>
      <!-- 修改 -->
      <el-dialog
        title="修改跟踪"
        :visible.sync="showDia_edit"
        append-to-body
        width="40%"
        center
        @close="closeDia_edit"
      >
        <div>
          <el-form
            label-position="right"
            label-width="80px"
            ref="editForm"
            :model="addFormDatas"
            :rules="rules1"
          >
            <el-form-item label="跟踪类型" prop="documentStatus">
              <el-select
                disabled
                class="queryInput"
                v-model="addFormDatas.documentStatus"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in documentStatusList"
                  :key="item.statusVal"
                  :label="item.showName"
                  :value="item.statusVal"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关联单据" prop="documentNumber">
              <el-input
                disabled
                type="textarea"
                :rows="2"
                placeholder="录入申请打包单号"
                v-model="addFormDatas.documentNumber"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述内容" prop="content">
              <el-input
                type="textarea"
                :rows="2"
                v-model="addFormDatas.content"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="2"
                v-model="addFormDatas.remarks"
              ></el-input>
            </el-form-item>
            <el-form-item label="发生时间">
              <el-date-picker
                style="width: 100%"
                v-model="addFormDatas.operationTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="addFormDatas.isShow"
                >是否显示到运单轨迹</el-checkbox
              >
            </el-form-item>
            <el-form-item label="上传图片">
              <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="6"
              ></uploadimgs>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmEdit('editForm')"
            >提 交</el-button
          >
        </div>
      </el-dialog>

      <!--  -->
      <el-dialog
        title="查看图片"
        :visible.sync="showBigImgs"
        append-to-body
        width="60%"
        center
      >
        <div class="wtl_displayFlex">
          <div class="imgItems" v-for="(item, index) in bigImgs" :key="index">
            <el-image
              style="width: 200px; height: 200px"
              :src="item.fileUrl"
              :preview-src-list="bigImgUrls"
            >
            </el-image>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showBigImgs = false"
            >关闭</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import sorttable from "@/components/sortTemplate.vue";
import { apiList, Api } from "@/assets/js/api";
import tools from "@/assets/js/tool";
import draggable from "vuedraggable"; //拖拽组件
import paging from "@/components/pagings.vue";
import multitime from "@/components/multiTime.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
// import { axios_file } from "@/assets/js/http_axios";
export default {
  inject: ["reload"],
  components: {
    // mytables,
    draggable,
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    uploadimgs,
  },
  data() {
    return {
      isActive: false, //输入框绑定动态class
      judge: true, //输入框绑定动态class
      MoreConditions: "更多条件", //输入框绑定动态class
      queryData: {
        documentNumber: "",
        documentStatus: "",
        content: "",
        isShow: "",
      },
      // ======公用组件==========
      pageNum: 1, //页码
      total: 0,
      sizeList: [10, 20, 50, 100, 200],
      size: 50, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      tableHeigth: "50vh",
      tabelHeadeTitle: [
        {
          name: "客户跟踪号",
          field: "number",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "内容描述",
          field: "content",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "关联单号",
          field: "documentNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "单据类型",
          field: "documentStatusShow",
          width: "80",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否展示",
          field: "isShowShow",
          width: "80",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "发生时间",
          field: "operationTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "80",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData: [],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      uploadUrl: "", //上传路径
      sortName: "模板名", //排序名
      pageGroupName: "customerServiceTrack", //页面标识

      writeoffStatusList: [], //核销状态
      approveStatusList: [
        {
          statusVal: "",
          showName: "全部",
        },
        {
          statusVal: "0",
          showName: "不显示",
        },
        {
          statusVal: "1",
          showName: "显示",
        },
      ], //审核状态类别
      WarehouseList: [], //仓库下拉列表
      objectStatusList: [], //结算对象类型
      documentStatusList: [], //单据类型
      currentSelectData: [], //选中的数据
      ids: [], //选中的id数据

      showDia_edit: false,
      showDia1: false,
      documentNumbers: "",
      documentStatus: "bill_pack_v1:document_status",
      //   diaTitle1: "新建客服跟踪",
      addFormDatas: {
        content: "",
        documentNumber: "",
        documentStatus: "",
        isShow: false,
        operationTime: "",
        remarks: "",
      },
      rules1: {
        documentNumber: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入", trigger: "blur" }],
        documentStatus: [
          { required: true, message: "请输入", trigger: "change" },
        ],
      },

      // 时间组件
      timeTypes: [
        //  时间类型
        {
          value: "0",
          label: "创建时间",
        },
        {
          value: "1",
          label: "发生时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      showBigImgs: false, //查看图片
      bigImgs: [],
      bigImgUrls: [],
      fileNameLists: [], //修改时的文件列表
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.uploadUrl = this.common.uploadUrl;
    if (this.originalTabelHeadeTitle.length == 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.myTableHeard = this.tabelHeadeTitle;
    this.getGroupFindFieldSort(); //获取用户自定义表头

    this.endTime_a = tools.getCurrentDate(); //今天的时间;
    this.startTime_a = tools.getFlexDate(-10); //10天前的时间

    this.getStatusValList("bill_kf_track_record_v2.document_status"); //客服跟踪单据类型
  },
  mounted() {
    const that = this;
    this.getData();
  },
  watch: {},
  methods: {
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    changeFileList(array) {
      this.fileNameLists = array;
      this.fileNames = array.map((item) => {
        return item.fileName;
      });
    },
    // 查看附件
    lookFile(id) {
      Api.getBillKfTrackRecordFileV2({ recordId: id }).then((res) => {
        let result = res.data.result || [];
        if (result.length == 0) {
          this.$message.warning("当前跟踪单没有相关的文件");
        } else {
          this.showBigImgs = true;
          this.bigImgs = result;
          this.bigImgUrls = result.map((item) => {
            return item.fileUrl;
          });
        }
      });
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    // 时间组件方法
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    //输入框绑定动态class
    more() {
      this.isActive = !this.isActive;
      this.judge = !this.judge;
      this.fetTableHeight();
      if (this.judge == false) {
        this.MoreConditions = "更多条件";
      } else {
        this.MoreConditions = "收起条件";
      }
    },
    // 提交新建
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 提交修改
    confirmEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.addFormDatas));

          console.log(datas);
          console.log(this.fileNameLists);
          let fileNames = this.fileNameLists.map((item) => {
            return item.name;
          });
          delete datas.documentStatusShow;
          delete datas.documentStatus;
          delete datas.documentNumber;
          delete datas.createUserName;
          delete datas.isShowShow;
          delete datas.number;
          datas.fileIds = fileNames || [];
          datas.isShow = datas.isShow ? "1" : "0";
          datas.sign = tools.getSign(datas);
          Api.updateBillKfTrackRecordV2(datas).then((res) => {
            this.$message.success(res.data.message || "提交成功");
            this.showDia_edit = false;
            this.getData();
          });
        } else {
        }
      });
    },
    // 关闭重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
    },
    // 关闭重置弹窗数据
    closeDia_edit(e) {
      this.showDia_edit = e || false;
    },
    // 获取状态展示值
    getStatusValList(status) {
      let param = {
        tableAndFieldName: status,
      };

      Api.getStatusValList(param).then((res) => {
        // 核销状态
        if (status == "bill_kf_track_record_v2.document_status") {
          let documentStatusList = res.data.result || [];
          this.documentStatusList = documentStatusList;
          let objs = {
            statusVal: "",
            showName: "全部",
          };
          this.documentStatusList.unshift(objs);
        }
      });
    },

    // 删除
    delBtns() {
      if (this.currentSelectData.length < 1) {
        this.$message.warning("请至少选择一条跟踪数据进行删除");
        return false;
      }
      let ids = [];
      this.currentSelectData.forEach((item) => {
        ids.push(item.recordId);
      });
      this.$confirm("是否删除选中的跟踪单号?", "提示:")
        .then(() => {
          let param = {
            recordIds: ids,
          };
          param.sign = tools.getSign(param);
          Api.delBillKfTrackRecordV2(param).then((res) => {
            this.$message.success(res.data.message || "删除成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    //新建修改
    financeExamineBtn(a) {
      let examine = a; //1=新建,2=修改
      if (examine == 1) {
        // 新建
        this.showDia1 = true;
      } else {
        // 编辑

        if (this.currentSelectData.length != 1) {
          this.$message.warning("请选择1条数据进行修改");
          return;
        }
        this.addFormDatas = this.currentSelectData[0];
        this.addFormDatas.isShow = this.currentSelectData[0].isShow
          ? true
          : false;
        console.log(this.addFormDatas);

        Api.getBillKfTrackRecordFileV2({
          recordId: this.currentSelectData[0].recordId,
        }).then((res) => {
          let result = res.data.result || [];
          this.fileNameLists = result.map((item) => {
            let objs = {
              name: item.fileId,
              url: item.fileUrl,
            };
            return objs;
          });
        });
        this.showDia_edit = true;
      }
    },

    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },
    // 上传导出模板
    uploadSectionFile(param) {
      ////console.log(param);
      const file = param.file,
        fileName = file.name;

      // 根据后台需求数据格式
      const form = new FormData();
      // 文件对象
      form.append("file", file);
      // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      form.append("fileName", fileName);
      let signArr = [
        {
          key: "fileName",
          val: fileName,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      form.append("sign", sign);
      // 项目封装的请求方法，下面做简单介绍
      Api.uploadFile(form)
        .then((res) => {
          if (res.data.status == "success") {
            let fileName = res.data.result.fileName;

            let signArr = [
              {
                key: "groupName",
                val: this.pageGroupName,
              },
              {
                key: "templateName",
                val: this.sortName,
              },
              {
                key: "fileName",
                val: fileName,
              },
            ];
            let sign_ = tools.getMD5Sign(signArr);
            Api.saveExportTemplate({
              groupName: this.pageGroupName,
              templateName: this.sortName,
              fileName: fileName,
              sign: sign_,
            }).then((res) => {
              this.$message.success(res.data.message || "更新成功");
              this.show_upload = false;
            });
          }
        })
        .catch((err) => {});
    },

    // 下载用户导出模板
    exportTemplateDownload() {
      var fieldName = this.fieldName;
      var head = this.head;
      if (head.length == 0) {
        let fieldNames = [];
        let heads = [];
        for (var i = 0; i < this.myTableHeard.length; i++) {
          if (this.myTableHeard[i].isShow) {
            fieldNames.push(this.myTableHeard[i].field);
            heads.push(this.myTableHeard[i].name);
          }
        }
        fieldName = fieldNames;
        head = heads;
      }
      //加密数组格式
      let signArr = [
        {
          key: "fieldName",
          val: fieldName,
        },
        {
          key: "head",
          val: head,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      let param = {
        fieldName: fieldName,
        head: head,
        sign: sign,
      };
      Api.exportTemplateDownload(param).then((res) => {
        let downloadurl = res.data.result.fileUrl || "";
        //下载(这里其实是直接访问)
        var a = document.createElement("a");
        a.setAttribute("href", downloadurl);
        a.setAttribute("target", "_blank");
        a.click();
      });
    },
    // 真正导出
    templateDataExport(customizedExportId) {
      let that = this;
      let datas = that.tableData;
      let parm = {
        customizedExportId: customizedExportId, //模板id
        className: that.className,
        data: datas,
      };
      let signarr = tools.getSignArr(parm);
      let signs_e = tools.getMD5Sign(signarr);
      Api.templateDataExport({
        customizedExportId: customizedExportId,
        className: that.className,
        data: JSON.stringify(datas),
        sign: signs_e,
      }).then((res) => {
        //下载(这里其实是直接访问)
        let downloadurl = res.data.result.fileUrl;
        var a = document.createElement("a");
        a.setAttribute("href", downloadurl);
        a.setAttribute("target", "_blank");
        a.click();
      });
    },
    // 上传按钮
    upLoadBtn() {
      this.show_upload = true;
    },
    // 点击导出按钮
    exportBtn() {
      let that = this;
      let fieldName = [];
      let head = [];
      for (var i = 0; i < this.myTableHeard.length; i++) {
        if (this.myTableHeard[i].isShow) {
          fieldName.push(this.myTableHeard[i].field);
          head.push(this.myTableHeard[i].name);
        }
      }
      this.fieldName = fieldName;
      this.head = head;

      // 1,先获取用户导出模板
      Api.getUserExportTemplate({
        groupName: this.pageGroupName,
      }).then((res) => {
        if (res.data.result && res.data.result[0].customizedExportId) {
          // 有自定义模板

          let customizedExportId = res.data.result[0].customizedExportId;
          that.templateDataExport(customizedExportId);
        } else {
          //没有自定义模板,就是下载一个
          tools.dynamicExport(
            this.myTableHeard,
            this.className,
            this.tableData,
            "其他支出列表"
          );
        }
      });
    },
    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    // 重置table高度
    resetHeight() {
      return new Promise((resolve, reject) => {
        this.tableHeigth = 0;
        resolve();
      });
    },
    // 设置table高度
    fetTableHeight() {
      this.resetHeight().then((res) => {
        this.tableHeigth = this.getHeight();
        this.$nextTick(() => {
          this.$refs.mytable.doLayout();
        });
      });
    },
    // 获取表格高度
    getHeight() {
      let windonHeight = document.body.clientHeight;
      let queryHeigth;
      if (this.judge == true) {
        queryHeigth = this.$refs.queryCriteria.offsetHeight; //查询框
      } else {
        queryHeigth = 50;
      }
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表
      let pagsHeigth = 40; //分页组件
      let heardHeight = 60; //头部(黑色部分)
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + heardHeight;
      return Math.floor(windonHeight - otherHeight - 10) || "50vh"; //
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    // 刷新页面==>
    reload_s() {
      this.reload(); //App.Vue里面的方法
    },
    // 获取数据
    getData() {
      let that = this;
      let startCreateTime = ""; //开始的创建时间
      let endCreateTime = ""; //结束-创建时间
      let startOperationTime = ""; //开始发生时间
      let endOperationTime = "";
      if (that.endTime_a) {
        if (this.timeType == "0") {
          // 0==创建时间, 1==发生时间
          endCreateTime = that.endTime_a + " " + "23:59:59";
        } else {
          endOperationTime = that.endTime_a + " " + "23:59:59";
        }
      }
      if (that.startTime_a) {
        if (this.timeType == "0") {
          // 0==创建时间, 1==发生时间
          startCreateTime = that.startTime_a + " " + "00:00:00";
        } else {
          startOperationTime = that.startTime_a + " " + "00:00:00";
        }
      }

      let formData = {
        documentNumber: this.queryData.documentNumber,
        documentStatus: this.queryData.documentStatus,
        content: this.queryData.content,
        isShow: this.queryData.isShow,
        endCreateTime: endCreateTime,
        startCreateTime: startCreateTime,
        endOperationTime: endOperationTime,
        startOperationTime: startOperationTime,
        pageStart: this.pageNum,
        pageTotal: this.size,
      };

      Api.getBillKfTrackRecordListV2(formData).then((res) => {
        if (res.data.status == "success") {
          that.className = res.data.result.className || "";
          that.tableData = res.data.result.data || [];
          that.total = res.data.result.pageCount || 0;

          this.fetTableHeight();
        }
      });
    },
    // 查询按钮
    queryBtn_ok() {
      this.pageNum = 1;
      this.getData();
    },
    // 重置按钮
    queryBtn_cz() {
      this.queryData = {
        documentNumber: "",
        documentStatus: "",
        content: "",
        isShow: "",
      };
      this.startTime_a = "";
      this.endTime_a = "";
    },
    // 获取自定义的排序,没有就用默认的
    getGroupFindFieldSort() {
      let that = this;
      Api.getGroupFindFieldSort({
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      }).then((res) => {
        let arr = res.data.result || [];
        if (arr.length > 0) {
          if (arr[0].sortObject) {
            that.myTableHeard = JSON.parse(arr[0].sortObject);
            this.sortName = arr[0].sortName;
          }
        } else {
          that.myTableHeard = that.tabelHeadeTitle;
        }
        let totalArr = [];
        //提取需要合计的字段
        for (var i = 0; i < that.myTableHeard.length; i++) {
          if (that.myTableHeard[i].isTotal) {
            totalArr.push(that.myTableHeard[i].field);
          }
        }
        that.totalArr = totalArr;
      });

      that.$nextTick(() => {
        that.$refs.mytable.doLayout();
      });
    },
    // 设置模板按钮
    myModel() {
      let that = this;
      that.show_sortTableHeard = true;
      that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    // 表格选择事件
    handleSelectionChange(e) {
      ////console.log(e);
      this.currentSelectData = e || [];
    },
    // 排序==>取消按钮
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let signs = [
        {
          key: "sortName",
          val: this.sortName, //模板名称
        },
        {
          key: "groupName",
          val: this.pageGroupName, //页面标识
        },
        {
          key: "sortObject",
          val: JSON.stringify(sortObject),
        },
      ];

      let sign = tools.getMD5Sign(signs);

      let param = {
        // apiPath: apiList.api_packageList, //综合查询接口路径
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
        sign: sign,
      };
      Api.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getGroupFindFieldSort();
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗
    closeDias(e) {
      this.show_sortTableHeard = e;
    },
    // 合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property == that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  // return prev + curr;
                  return tools.mathToFixed(tools.add(prev, curr), 2);
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    //分页
    handleSizeChange(val) {
      this.size = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    // 上一页
    handlePrevPage() {
      this.pageNum = this.pageNum - 1 || 1;
      this.getData();
    },
    // 下一页
    handleNextPage() {
      this.pageNum = this.pageNum + 1 || 1;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.tableBox {
  height: calc(100% - 260px);
}
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.HeadInputbox .item_right .singleinp {
  width: 18%;
  ::v-deep {
    .el-date-editor.el-input {
      width: 100%;
    }
  }
}

.wtl_displayFlex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.imgItems {
  width: 200px;
  height: 200px;
  margin: 20px;
}
</style>
